import {
  isAdmin,
  isGlobalAdmin,
  ROLE_NUMBER_ADMINISTRATOR,
  ROLE_NUMBER_CI,
  ROLE_NUMBER_CLINICAL,
  ROLE_NUMBER_CLINICAL_CI,
  ROLE_NUMBER_CLINICAL_MANAGER,
} from 'list-types-public';

// Plain rules only, with no Angular service: the nav service reads them, and the auth service imports
// the nav service. KpiAccess (kpi-access.service.ts) reads the session.

// The roles that read the KPIs without editing them, each with the ADT Report in its menu. Any role not
// listed here or among the admins is refused, a new one included, until it is added on purpose. Keep in
// sync with the server's requireKpiViewer.
const KPI_VIEWER_ROLES: readonly number[] = [
  ROLE_NUMBER_CI,
  ROLE_NUMBER_CLINICAL_CI,
  ROLE_NUMBER_CLINICAL,
  ROLE_NUMBER_CLINICAL_MANAGER,
  ROLE_NUMBER_ADMINISTRATOR,
];

/** Who sets targets and defines KPIs: the admins and the Global Admin, the same rule as the server's requireAdmin. */
export function canEditKpis(roleValue: number): boolean {
  const role = Number(roleValue);
  return isAdmin(role) || isGlobalAdmin(role);
}

/**
 * Who sees the KPI pages: the admins and the viewer roles, the same rule as the
 * server's requireKpiViewer. The route guard and the nav menu (through
 * NavigationScreensService's NavCtx) both read it from here.
 */
export function canViewKpis(roleValue: number): boolean {
  const role = Number(roleValue);
  return canEditKpis(role) || KPI_VIEWER_ROLES.includes(role);
}
